module.exports = __webpack_public_path__ + "static/Portfolio04-d0e59574a58ff79f00a1d4114684b960.jpg";